<template>
  <div class="product-add">

    <el-form size="small" ref="form" :model="form" label-width="80px">
      <div class="common-form">基本信息</div>

      <el-form-item label="店铺类型">
        <el-select v-model="form.type" placeholder="请选择店铺类型" >
          <el-option :label="item.name" :value="item.type" v-for="(item,index) in typeList" :key='index'></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="创建方式">
        <el-radio-group v-model="form.auth_type">
          <el-radio v-if="form.type == 'wxapp'" :label="1">扫码授权</el-radio>
          <el-radio :label="0">手工授权</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">下一步</el-button>
      </el-form-item>


    </el-form>

  </div>
</template>

<script>
  import PortApi from '@/api/port.js';
  export default {
    components: {
    },
    data() {
      return {
        /*切换菜单*/
        // activeIndex: '1',
        typeList:[
          {
                      type:"wxapp",
                      name:'微信小程序'
                    },
                    {
                      type:"wxmp",
                      name:'微信公众号'
                    },
                    {
                      type:"h5",
                      name:'H5'
                    },
                    {
                      type:"android",
                      name:'安卓'
                    },
                    {
                      type:"ios",
                      name:'IOS'
                    },
                    {
                      type:"zhifubao",
                      name:'支付宝小程序'
                    },
                    {
                      type:"baidu",
                      name:'百度小程序'
                    },
                    {
                      type:"douyin",
                      name:'字节跳动小程序'
                    },
                    {
                      type:"qq",
                      name:'QQ小程序'
                    },
                    {
                      type:"quick",
                      name:'快应用'
                    },
                    {
                      type:"360",
                      name:'360小程序'
                    }
        ],
        /*form表单数据*/
        form: {
          type:'',
          auth_type:1,
        },
        loading: false,
      };
    },
    created() {
      /*引用的select_region 初始化*/
      // console.log(select_region);
    },

    methods: {
      /*下一步*/
      onSubmit() {
        let self = this;
        let form = self.form;
        if(form.type==''){
          self.$message({
            message: '请先选择店铺类型',
            type: 'success'
          });
        }
        self.select();
      },
      select(){
        let self =this;
        let params =this.form
        PortApi.select(params,true).then(data=>{
          if(data.code!=1){
            self.$message({
              message: data.msg,
              type: 'error'
            });
          }else{
            if(self.form.type=='wxapp'){
              if(self.form.auth_type==1){
                  PortApi.authUrl({},true).then(data=>{
                    window.open(data.data.url);
                }).catch(error=>{
                  self.loading=false;
                })

              }else{
                this.$router.push({
                  path: '/plus/port/port/add',
                  query: {
                    type: self.form.type,
                    auth_type:self.form.auth_type,
                  }
                })
              }
            }
            if(self.form.type=='wxmp'){
              if(self.form.auth_type==1){
                self.$message({
                  message: '微信公众号快速授权尚未开放',
                  type: 'error'
                });

              }else{
                this.$router.push({
                  path: '/plus/port/port/add',
                  query: {
                    type: self.form.type,
                    auth_type:self.form.auth_type,
                  }
                })
              }
            }else{
              this.$router.push({
                path: '/plus/port/port/add',
                query: {
                  type: self.form.type,
                  auth_type:self.form.auth_type,
                }
              })
            }
          }
        }).catch(error=>{
          self.loading=false;
        })

      }

    }

  };
</script>

<style lang="scss" scoped>
  .product-add {
    padding-bottom: 50px;
  }

  .img {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/port/port/select.vue